function observeCartBtn() {
    if (typeof BSS_B2B !== 'undefined' && BSS_B2B) {
        setTimeout(() => {
            const observer = new MutationObserver((MutationList) => {
                for (let item of MutationList) {
                    if (item.target.classList?.contains('cart-recommendations')) {
                        const container = document.querySelector('product-recommendations');

                        if (container) {
                            window.dispatchEvent(new Event('scroll'));
                        }
                    }
                }
            });

            observer.observe(document.body, {
                childList: true,
                subtree: true,
            });
        }, 300);
    }

    const compareBtn = document.querySelector('.btn.btn--primary.js-trigger-compare');

      if (!compareBtn) return;

      compareBtn.addEventListener('click', () => { 
        setTimeout(() => {
            BSS_B2B.observer.productSubject.notifyObserver('ProductMutate', 'ProductPriceMutate');
        }, 3000);
    });
}

document.addEventListener('DOMContentLoaded', () => {
    setTimeout(() => {
        const hasCpRule = Boolean(BSS_B2B?.cp?.utils?.common?.getCustomerAppliedRules().length);

        if (!hasCpRule) {
            return;
        }

        observeCartBtn();
    }, 2000);
});
